<div class="totals" [attr.aria-live]="ariaLive()" [attr.role]="role()">
    @if (data(); as productCard) {
        <div class="total-item">
            <p class="body-0">Subtotal</p>
            <div class="quantity">
                @if (productCard.subtotalDiscountedPrice) {
                    <p>
                        <span class="cta">{{ productCard.subtotalDiscountedPrice | currency }}</span>
                        @if (canRedeemPoints()) {
                            <span class="points-equiv">
                                or {{ productCard.subtotalDiscountedPoints | appDigitsGrouping }} pts
                            </span>
                        }
                    </p>
                    @if (canRedeemPoints()) {
                        <lib-cart-old-price
                            [inline]="true"
                            [points]="productCard.subtotalPoints"
                            [price]="productCard.subtotalPrice"
                        />
                    }
                } @else {
                    <p>
                        <span class="cta">{{ productCard.subtotalPrice | currency }}</span>
                        @if (canRedeemPoints()) {
                            <span class="points-equiv">
                                or {{ productCard.subtotalPoints | appDigitsGrouping }} pts
                            </span>
                        }
                    </p>
                    @if (subtotalPointsStandardRate() && canRedeemPoints()) {
                        <lib-cart-old-price [inline]="true" [points]="subtotalPointsStandardRate()!" [price]="null" />
                    }
                }
            </div>
        </div>
        <div class="total-item">
            <p class="body-0">Shipping</p>
            <p class="body-0">Free</p>
        </div>
        <div class="total-item">
            <p class="body-0">Tax</p>
            @if (hideTax()) {
                <p class="body-0">Finalized at checkout</p>
            } @else {
                <div class="quantity">
                    <p>
                        <span class="body-0">
                            <span class="primary-cta">{{ vm().productTax?.taxAmountUSD || 0 | currency }}</span>
                            @if (canRedeemPoints()) {
                                <span class="points-equiv">
                                    or {{ (discountedTaxPoints() ?? vm().productTax?.taxAmountPoints ?? 0) | appDigitsGrouping }} pts
                                </span>
                            }
                        </span>
                    </p>
                    @if (showTaxStrikethrough() && canRedeemPoints()) {
                        <lib-cart-old-price [inline]="true" [points]="vm().productTax!.taxAmountPoints" [price]="null" />
                    }
                </div>
            }
        </div>
        <div class="divider-line"></div>
        <div class="total-item">
            <p class="subheading-1 total">{{ totalLabel() }}</p>
            <div class="quantity">
                @if (productCard.subtotalDiscountedPrice) {
                    <p class="body-0">
                        <span class="primary-cta">{{ totalDiscountedPrice() | currency }}</span>
                        @if (canRedeemPoints()) {
                            <span class="points-equiv">
                                or {{ productCard.subtotalDiscountedPoints | appDigitsGrouping }} pts
                            </span>
                        }
                    </p>
                    @if (canRedeemPoints()) {
                        <lib-cart-old-price
                            [inline]="true"
                            [points]="totalDiscountedPointsStandardRate() ?? totalPoints()"
                            [price]="totalPrice()"
                        />
                    }
                } @else {
                    <p class="body-0">
                        <span class="primary-cta">{{ totalPrice() | currency }}</span>
                        @if (canRedeemPoints()) {
                            <span class="points-equiv"> or {{ totalPoints() | appDigitsGrouping }} pts </span>
                        }
                    </p>
                    @if (totalPointsStandardRate() && canRedeemPoints()) {
                        <lib-cart-old-price [inline]="true" [points]="totalPointsStandardRate()!" [price]="null" />
                    }
                }
            </div>
        </div>
    } @else {
        <ng-container *ngTemplateOutlet="skeletonService.rectangleTemplate()"></ng-container>
    }
</div>
